import { useState } from 'react';
import { Form } from '@radix-ui/react-form';
import { Link, Strong, TextField, Flex } from '@radix-ui/themes';

import { redirectTo } from '../../utils/CommonUtil';
import { ADMIN_BLOG_REQUESTS_ADDRESS, getBlogAddress } from '../../utils/PageAddressUtil';
import RequestUtil from '../../utils/APIRequestUtil';
import { getCookie } from '../../utils/CookieUtil';

const inputStyle = { width: '100%', maxWidth: '400px' };

export default function AdminBlogRequestTable({ blogRequest }) {
    const id = blogRequest.id;
    const blogAddress = getBlogAddress(blogRequest.domainName);

    const [formData, setFormData] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const approve = (e) => {
        e.preventDefault();

        const url = `/api/admin/blog-requests/${id}/approve`;
        RequestUtil.patch(url, JSON.stringify(formData), {
            'Content-Type': 'application/json',
            'username': getCookie('username'),
            'sessionId': getCookie('sessionId')
        });

        redirectTo(ADMIN_BLOG_REQUESTS_ADDRESS, 3);
    }

    const reject = (e) => {
        e.preventDefault();

        const url = `/api/admin/blog-requests/${id}/reject`;
        RequestUtil.patch(url, JSON.stringify(formData), {
            'Content-Type': 'application/json',
            'username': getCookie('username'),
            'sessionId': getCookie('sessionId')
        });

        redirectTo(ADMIN_BLOG_REQUESTS_ADDRESS, 3);
    }

    const uncollected = (e) => {
        e.preventDefault();

        const url = `/api/admin/blog-requests/${id}/uncollected`;
        RequestUtil.patch(url, JSON.stringify(formData), {
            'Content-Type': 'application/json',
            'username': getCookie('username'),
            'sessionId': getCookie('sessionId')
        });

        redirectTo(ADMIN_BLOG_REQUESTS_ADDRESS, 3);
    }

    const deleteAllInfos = (e) => {
        e.preventDefault();

        const url = `/api/admin/blog-requests/${id}`;
        RequestUtil.delete(url, JSON.stringify(formData), {
            'Content-Type': 'application/json',
            'username': getCookie('username'),
            'sessionId': getCookie('sessionId')
        });

        redirectTo(ADMIN_BLOG_REQUESTS_ADDRESS, 3);
    }

    return (
        <div className="redesign-detail-panel">
            <table className="redesign-admin-detail-table">
                    <tbody>
                        <tr>
                            <th><Strong>博客名称</Strong></th>
                            <td>{blogRequest.name}</td>
                        </tr>
                        <tr>
                            <th><Strong>博客描述</Strong></th>
                            <td>{blogRequest.description}</td>
                        </tr>
                        <tr>
                            <th><Strong>RSS 地址</Strong></th>
                            <td><Link href={blogRequest.rssAddress}>{blogRequest.rssAddress}</Link></td>
                        </tr>
                        <tr>
                            <th><Strong>博主邮箱</Strong></th>
                            <td>{blogRequest.adminEmail}</td>
                        </tr>
                        <tr>
                            <th><Strong>提交时间</Strong></th>
                            <td>{blogRequest.requestedAt}</td>
                        </tr>
                        <tr>
                            <th><Strong>博客详情页</Strong></th>
                            <td><Link href={blogAddress}>{blogAddress}</Link></td>
                        </tr>
                        <tr>
                            <th><Strong>草稿文章抓取</Strong></th>
                            <td>
                                <ul className="redesign-admin-post-list">
                                    {
                                        blogRequest.posts.map(
                                            (post, index) => (
                                                <li key={index}>
                                                    <a href={post.link}>{post.title}</a>
                                                </li>
                                            )
                                        )
                                    }
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <th><Strong>失败原因</Strong></th>
                            <td>{blogRequest.reason}</td>
                        </tr>
                        <tr>
                            <th><Strong>审核状态</Strong></th>
                            <td>{blogRequest.statusInfo}</td>
                        </tr>
                        <tr>
                            <th><Strong>操作</Strong></th>
                            <td className="redesign-admin-actions">
                                {
                                    blogRequest.status == 'system_check_valid' ? (
                                        <form onSubmit={approve}>
                                            <button className="redesign-btn-success" type="submit">审批通过</button>
                                        </form>
                                    ) : null
                                }

                                <Form onSubmit={reject}>
                                    <Flex gap="2" align="center" wrap="wrap" mt="2">
                                        <TextField.Root className="redesign-form-field" style={inputStyle} name="reason" placeholder="驳回原因" onChange={handleChange} />
                                        <button className="redesign-btn-danger" type="submit">驳回</button>
                                    </Flex>
                                </Form>

                                <Form onSubmit={uncollected}>
                                    <Flex gap="2" align="center" wrap="wrap" mt="2">
                                        <TextField.Root className="redesign-form-field" style={inputStyle} name="reason" placeholder="移出原因" onChange={handleChange} />
                                        <button className="redesign-btn-danger" type="submit">移出收录名单</button>
                                    </Flex>
                                </Form>

                                <Form onSubmit={deleteAllInfos}>
                                    <button className="redesign-btn-danger" type="submit" style={{ marginTop: 12 }}>删除全部数据</button>
                                </Form>
                            </td>
                        </tr>
                    </tbody>
                </table>
        </div>
    )
}